import './Loading.css'

const Loading = () => {
  return (
    <div className='spinner' role='status'>
      <span className='sr-only'>Loading</span>
    </div>
  )
}

export default Loading